import { Injectable } from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {PayLinksModelDto} from "../models/paylinks.model";

@Injectable({
  providedIn: 'root'
})
export class PaylinkUpdateDataService {
  paymentLinkDetail$: BehaviorSubject<PayLinksModelDto | null> = new BehaviorSubject<PayLinksModelDto | null>(null)
}
